import { Carousel, CarouselProps } from 'common/Carousel'
import { useStore } from 'lib/store'
import { toJS } from 'mobx'
import { observer } from 'mobx-react-lite'
import { Post } from 'models/Post'
import { Flex } from 'primitives/Flex'
import { AssetSlide } from '../AssetSlide'

interface PostAssetsCarouselProps extends CarouselProps {
  post: Post
  fullMediaMode?: boolean
}
const _PostAssetsCarousel = ({
  post,
  onClick,
  fullMediaMode = false,
  ...props
}: PostAssetsCarouselProps) => {
  const store = useStore()

  // We fix the height for all assets to the first asset
  const coverAssetHeight = post.assets[0]?.heightPercentOfWidth

  const getInitialAssetIndex = () => {
    const activeIndex = post.assets.findIndex((asset) => asset.viewing === true)
    return Math.max(activeIndex, 0)
  }
  const moreThanTwoAssets = post.assets.length > 2

  return (
    <Carousel
      touchEnabled={store.ui.isMobile}
      controls={moreThanTwoAssets}
      initialIndex={getInitialAssetIndex()}
      onSlide={(index) => post.setViewingAsset(index)}
      {...props}
    >
      <Flex
        css={{ overflowX: moreThanTwoAssets ? 'scroll' : 'unset', width: '100%', height: '100%' }}
      >
        {post.assets.map((asset, index) => {
          return (
            <AssetSlide
              key={`${post.assets[index]?.media.url}-${asset.ordinal + 1}`}
              asset={post.assets[index]}
              height={!fullMediaMode ? coverAssetHeight : undefined}
              onClick={onClick}
              css={{
                minWidth: moreThanTwoAssets ? '40%' : '47%',
                borderRadius: '8px',
                marginRight: '10px',
                objectFit: 'cover'
              }}
            />
          )
        })}
      </Flex>
    </Carousel>
  )
}

export const PostAssetsCarousel = observer(_PostAssetsCarousel)
